// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonUpdateSpacerCaption } from './LyonUpdateSpacerCaption';
import { LyonUpdateSpacerName } from './LyonUpdateSpacerName';

export const LyonUpdateFormContentSpacer = constant(() => (
  <Block width="65%">
    <LyonUpdateSpacerName />
    <LyonUpdateSpacerCaption />
  </Block>
));
